module.exports = __webpack_public_path__ + "fonts/nanumgothic-regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Nanum_Gothic/nanumgothic-regular-webfont.ttf
// module id = 3442
// module chunks = 0